/**
 * Auth Layout
 * Layout for auth pages (login, register, etc.)
 */

import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { Box, Container,Paper } from '@mui/material';
import { useAuth } from '@/hooks';

export const AuthLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isInitialized, user } = useAuth();
  const from = (location.state as { from?: { pathname?: string } } | null)?.from?.pathname;

  // Redirect to dashboard if already authenticated
  useEffect(() => {
    if (isInitialized && isAuthenticated) {
      const defaultRoute = user?.role === 'student' ? '/student-portal' : '/admin/dashboard';
      navigate(from && from !== '/auth/login' ? from : defaultRoute, { replace: true });
    }
  }, [from, isAuthenticated, isInitialized, navigate, user]);

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // background: '#070A11',
      }}
    >
      <Container maxWidth="xs">
        <Paper sx={{
          p:4,
          // borderRadius:2
        }}>
          <Outlet/>
        </Paper>
        {/* <Box
          sx={{
            // bgcolor: '#12151B',
            borderRadius: 2,
            p: 4,
            boxShadow: '0 10px 40px rgba(0, 0, 0, 0.2)',
          }}
        >
          <Outlet />
        </Box> */}
      </Container>
    </Box>
  );
};

export default AuthLayout;
